module.exports = __webpack_public_path__ + "img/qronly.f724d4e5.jpeg";